import type { EmailData } from '@stratumn/studio-shared';

export const initialEmailData: EmailData = {
  dataSource: {
    template: '',
    selectedDestination: ''
  },
  dataSourceData: {
    templateVariables: null,
    to: ''
  }
};
